import {
  OperationKeyHandle,
  OperationKeyStore,
  operationKeyScope,
  useOperationKey,
} from './useOperationKey';
import { CreateDemandBatchVariables } from './useWarehouseDemandMutations';

/** What a demand series pins with its first attempt: the batch every retry resends (D-3). */
export interface PinnedDemandRequest {
  payload: CreateDemandBatchVariables;
}

/** The key of the series' pinned request, if one is pinned; never creates one. */
export function pinnedDemandKey(
  operationKeys: OperationKeyStore,
): string | undefined {
  return operationKeys.peek<PinnedDemandRequest>()?.payload.dto.operationKey;
}

/** The series target: a new request, whichever entry point raises it. */
export const NEW_DEMAND_REQUEST_TARGET = 'new';

/**
 * D-3: the "Zgłoś zapotrzebowanie" operation-key series, one per
 * organization. Every entry point (Produkty, the Zapotrzebowania tab, a
 * medication shortage) names it, so a request whose answer was lost is
 * resent with its key from wherever the form is opened next. It lives in
 * Phase 1's registry: it outlives the form and its host while unresolved and
 * is forgotten on logout.
 */
export function useDemandOperationKey(
  organizationId: string | undefined,
): OperationKeyHandle {
  return useOperationKey(
    operationKeyScope('demand', organizationId, NEW_DEMAND_REQUEST_TARGET),
  );
}
